import React from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'
import { AuthProvider, useAuth } from '../contexts/AuthContext/AuthContext'
import { ModalProvider } from '../contexts/ModalContext/ModalContext'
import { AuthPage } from '../components/auth/AuthPage/AuthPage'
import { Dashboard } from '../components/dashboard/Dashboard/Dashboard'
import { MapEditor } from '../components/editor/MapEditor/MapEditor'
import { AcceptShare } from '../components/share/AcceptShare'
import { TermsOfUse } from '../components/legal/TermsOfUse'
import { PrivacyPolicy } from '../components/legal/PrivacyPolicy'
import { PricingPage } from '../components/pricing/PricingPage'
import { BillingDashboard } from '../components/billing/BillingDashboard'
import { AccountLockGuard } from '../components/auth/AccountLockGuard/AccountLockGuard'
import { GlobalStyle, AppContainer, LoadingContainer } from './styled'

const AppContent: React.FC = () => {
  const { user, loading } = useAuth()

  if (loading) {
    return <LoadingContainer>Loading...</LoadingContainer>
  }

  return (
    <AppContainer>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              user ? (
                <AccountLockGuard>
                  <Dashboard />
                </AccountLockGuard>
              ) : (
                <AuthPage />
              )
            }
          />
          <Route
            path="/editor/:mapId"
            element={
              user ? (
                <AccountLockGuard>
                  <MapEditor />
                </AccountLockGuard>
              ) : (
                <AuthPage />
              )
            }
          />
          <Route
            path="/billing"
            element={
              user ? (
                <AccountLockGuard>
                  <BillingDashboard />
                </AccountLockGuard>
              ) : (
                <AuthPage />
              )
            }
          />
          <Route path="/share/:token" element={<AcceptShare />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />

          <Route path="/dashboard" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AppContainer>
  )
}

const App: React.FC = () => {
  return (
    <>
      <GlobalStyle />
      <AuthProvider>
        <ModalProvider>
          <AppContent />
        </ModalProvider>
      </AuthProvider>
    </>
  )
}

export { App }
